import { Table, Tag } from 'antd';
import React, { useState } from 'react';
import { AttestationProps, IUsers } from '../../../types/UsersType';
import { TableUsersProps } from '../../../types/TableProps';
import { ColumnsType } from 'antd/lib/table';
interface HrUsersTableProps {
  data: IUsers[];
  selectUser: React.Key[];
  choiceUserSwitch: (value: React.Key[]) => void;
}
const dataSource: ColumnsType<TableUsersProps> = [
  {
    title: 'Пользователь',
    dataIndex: 'name',
    width: '50%',
  },
  {
    title: 'Отдел',
    dataIndex: 'category_title',
    width: '14%',
  },
  {
    title: 'Пройдено тестов',
    dataIndex: 'tests_count',
    width: '11%',
  },
  {
    title: 'Статус',
    dataIndex: 'is_passed',
    width: '5%',
  },
  {
    title: 'Дата аттестации',
    dataIndex: 'complete_date',
    width: '15%',
  },
];
const headerStyle = {
  background: 'none',
  color: 'none',
};
const HrUsersTable = (props: HrUsersTableProps) => {
  const { data, choiceUserSwitch, selectUser } = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>(selectUser);
  const returnTag = (value: AttestationProps | null) => {
    if (value !== null) {
      if (value['is_passed'] === true) {
        return <Tag color={'success'}>{'Аттестован'}</Tag>;
      } else {
        return <Tag color={'error'}>{'Не аттестован'}</Tag>;
      }
    } else return <Tag color={'default'}>{'Не пройдена'}</Tag>;
  };

  const generateUserData = () => {
    return data.map((user: IUsers) => ({
      key: String(user.id),
      name: user.name,
      category_title: user.department?.title || '',
      tests_count: `${user.passed_user_tests_count} 
        / ${user.total_user_tests_count}`,
      is_passed: returnTag(user['attestation'] || null),
      complete_date: user.attestation ? user.attestation.complete_date : null,
    }));
  };
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    choiceUserSwitch(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <div>
      <Table
        rowSelection={rowSelection}
        columns={dataSource.map((column) => ({
          ...column,
          onHeaderCell: () => ({
            style: headerStyle,
          }),
        }))}
        dataSource={generateUserData()}
        bordered={true}
      />
    </div>
  );
};

export default HrUsersTable;
